/* eslint-disable no-unused-vars */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography
} from '@mui/material';
import React from 'react';

export default function PackageDetailsCollapsibleList({ items, label }) {
  return (
    <Grid item xs={12} sm={6}>
      <Accordion defaultExpanded={items?.length <= 5}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ fontWeight: 600 }}>
            {label} ({items?.length || 0})
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ul style={{ paddingLeft: '1.5rem', marginTop: 0 }}>
            {items?.map((item, index) => (
              <li key={index}>
                <Typography variant="body2">{item}</Typography>
              </li>
            ))}
          </ul>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
